/* Workbook gallery — scroll reveal + lightbox. Editor-safe, no dependencies. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----- Scroll reveal ----------------------------------------------------- */
  var revealObserver = null;
  if ('IntersectionObserver' in window && !reduceMotion) {
    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
  }

  function initReveal(root) {
    var gallery = root.querySelector ? root : document;
    var items = (root.matches && root.matches('.babaa-wb'))
      ? root.querySelectorAll('.babaa-wb__item')
      : gallery.querySelectorAll('.babaa-wb--reveal .babaa-wb__item');
    items.forEach(function (item) {
      if (revealObserver) {
        revealObserver.observe(item);
      } else {
        item.classList.add('is-visible');
      }
    });
  }

  /* ----- Lightbox ---------------------------------------------------------- */
  var lb = null; // overlay element
  var lbImg, lbPrev, lbNext;
  var current = []; // array of {src, alt}
  var index = 0;
  var lastFocus = null;
  var labels = { close: 'Close', previous: 'Previous image', next: 'Next image' };

  function buildLightbox() {
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'babaa-wb-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<button type="button" class="babaa-wb-lightbox__btn babaa-wb-lightbox__close" data-wb-close aria-label="' +
      esc(labels.close) + '">×</button>' +
      '<button type="button" class="babaa-wb-lightbox__btn babaa-wb-lightbox__btn--prev" data-wb-prev aria-label="' +
      esc(labels.previous) + '">‹</button>' +
      '<img class="babaa-wb-lightbox__img" alt="">' +
      '<button type="button" class="babaa-wb-lightbox__btn babaa-wb-lightbox__btn--next" data-wb-next aria-label="' +
      esc(labels.next) + '">›</button>';
    document.body.appendChild(lb);
    lbImg = lb.querySelector('.babaa-wb-lightbox__img');
    lbPrev = lb.querySelector('[data-wb-prev]');
    lbNext = lb.querySelector('[data-wb-next]');

    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.hasAttribute('data-wb-close')) closeLightbox();
      else if (e.target.hasAttribute('data-wb-prev')) step(-1);
      else if (e.target.hasAttribute('data-wb-next')) step(1);
    });
  }

  function esc(s) {
    return String(s).replace(/"/g, '&quot;');
  }

  function openLightbox(items, startIndex, galleryLabels) {
    if (galleryLabels) labels = galleryLabels;
    buildLightbox();
    current = items;
    index = startIndex;
    lastFocus = document.activeElement;
    render();
    lb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    lb.querySelector('[data-wb-close]').focus();
  }

  function closeLightbox() {
    if (!lb) return;
    lb.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function step(dir) {
    if (!current.length) return;
    index = (index + dir + current.length) % current.length;
    render();
  }

  function render() {
    var item = current[index];
    if (!item) return;
    lbImg.src = item.src;
    lbImg.alt = item.alt || '';
    var single = current.length < 2;
    lbPrev.hidden = single;
    lbNext.hidden = single;
  }

  function onKey(e) {
    if (e.key === 'Escape') closeLightbox();
    else if (e.key === 'ArrowLeft') step(-1);
    else if (e.key === 'ArrowRight') step(1);
  }

  /* Delegated trigger: works for blocks added later in the editor */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('.babaa-wb__trigger') : null;
    if (!trigger) return;
    var gallery = trigger.closest('.babaa-wb');
    if (!gallery || gallery.getAttribute('data-lightbox') !== 'true') return;
    e.preventDefault();

    var triggers = Array.prototype.slice.call(gallery.querySelectorAll('.babaa-wb__trigger'));
    var items = triggers.map(function (tr) {
      var img = tr.querySelector('img');
      return { src: img ? (img.currentSrc || img.src) : '', alt: img ? img.alt : '' };
    });
    var galleryLabels = {
      close: gallery.getAttribute('data-lb-close') || labels.close,
      previous: gallery.getAttribute('data-lb-prev') || labels.previous,
      next: gallery.getAttribute('data-lb-next') || labels.next
    };
    openLightbox(items, triggers.indexOf(trigger), galleryLabels);
  });

  /* ----- Boot + Theme editor lifecycle ------------------------------------ */
  function boot() {
    document.querySelectorAll('.babaa-wb--reveal').forEach(function (g) {
      initReveal(g);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var g = e.target.querySelector && e.target.querySelector('.babaa-wb--reveal');
    if (g) initReveal(g);
  });
})();
